import {
  USER_ADD_SETTING_FAIL,
  USER_ADD_SETTING_REQUEST,
  USER_ADD_SETTING_SUCCESS,
  GET_USER_SETTING_FAIL,
  GET_USER_SETTING_REQUEST,
  GET_USER_SETTING_SUCCESS,
  UPDATE_MARK_IN_USER_FAIL,
  UPDATE_MARK_IN_USER_REQUEST,
  UPDATE_MARK_IN_USER_SUCCESS,
  ADD_WORKING_FROM_IN_USER_FAIL,
  ADD_WORKING_FROM_IN_USER_REQUEST,
  ADD_WORKING_FROM_IN_USER_SUCCESS,
  GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_FAIL,
  GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_REQUEST,
  GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_SUCCESS,
  GET_COMPANY_ALL_SETTING_FAIL,
  GET_COMPANY_ALL_SETTING_REQUEST,
  GET_COMPANY_ALL_SETTING_SUCCESS,
} from "../../types/user/settingTypes";

export const addUserSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ADD_SETTING_REQUEST:
      return {
        ...state,
        settingLoading: true,
      };
    case USER_ADD_SETTING_SUCCESS:
      return {
        ...state,
        settingLoading: false,
        settingInfo: payload,
        settingError: "",
      };
    case USER_ADD_SETTING_FAIL:
      return {
        ...state,
        settingLoading: false,
        settingError: payload,
        settingInfo: [],
      };
    default:
      return state;
  }
};

export const getUserSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_SETTING_REQUEST:
      return {
        ...state,
        getSetLoading: true,
      };
    case GET_USER_SETTING_SUCCESS:
      return {
        ...state,
        getSetLoading: false,
        getSetInfo: payload,
        getSetError: "",
      };
    case GET_USER_SETTING_FAIL:
      return {
        ...state,
        getSetLoading: false,
        getSetError: payload,
        getSetInfo: [],
      };
    default:
      return state;
  }
};

export const getUserMArkReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_MARK_IN_USER_REQUEST:
      return {
        ...state,
        UpdateMarkLoading: true,
      };
    case UPDATE_MARK_IN_USER_SUCCESS:
      return {
        ...state,
        UpdateMarkLoading: false,
        UpdateMarkInfo: payload,
        UpdateMarkError: "",
      };
    case UPDATE_MARK_IN_USER_FAIL:
      return {
        ...state,
        UpdateMarkLoading: false,
        UpdateMarkError: payload,
        UpdateMarkInfo: [],
      };
    default:
      return state;
  }
};

export const AddUserWorkingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_WORKING_FROM_IN_USER_REQUEST:
      return {
        ...state,
        AddUserWorkingLoading: true,
      };
    case ADD_WORKING_FROM_IN_USER_SUCCESS:
      return {
        ...state,
        AddUserWorkingLoading: false,
        AddUserWorkingInfo: payload,
        AddUserWorkingError: "",
      };
    case ADD_WORKING_FROM_IN_USER_FAIL:
      return {
        ...state,
        AddUserWorkingLoading: false,
        AddUserWorkingError: payload,
        AddUserWorkingInfo: [],
      };
    default:
      return state;
  }
};

export const getUserPayrollReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_REQUEST:
      return {
        ...state,
        getPayrollSettingLoading: true,
      };
    case GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_SUCCESS:
      return {
        ...state,
        getPayrollSettingLoading: false,
        getPayrollSettingInfo: payload,
        getPayrollSettingError: "",
      };
    case GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_FAIL:
      return {
        ...state,
        getPayrollSettingLoading: false,
        getPayrollSettingError: payload,
        getPayrollSettingInfo: [],
      };
    default:
      return state;
  }
};

export const getUserAllCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_COMPANY_ALL_SETTING_REQUEST:
      return {
        ...state,
        getCompanySettingLoading: true,
      };
    case GET_COMPANY_ALL_SETTING_SUCCESS:
      return {
        ...state,
        getCompanySettingLoading: false,
        getCompanySettingInfo: payload,
        getCompanySettingError: "",
      };
    case GET_COMPANY_ALL_SETTING_FAIL:
      return {
        ...state,
        getCompanySettingLoading: false,
        getCompanySettingError: payload,
        getCompanySettingInfo: [],
      };
    default:
      return state;
  }
};
